export default {
  title: 'Username',
  label: 'Formats to be respected:',
  case1: '8 characters or more',
  case2: 'Different from your password',
  case3: 'Different from another account username',
  formatError: 'The username does not follow the expected format.',
};
